<template>

<div>
  <div
    ref='modalAddDeviceToLog'
    id="modalAddDeviceToLog"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalAddDeviceToLog"
    aria-hidden="true"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="modalAddDeviceToLog">Adicionar equipamento</h5>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label for="serial">{{ $t('serial') }}</label>
            <input
              type="text"
              id="serial"
              name="serial"
              class="form-control"
              :placeholder="$t('ph_serial')"
              v-model="deviceToAdd"
            >
          </div>
        </div>

        <div class="modal-footer">
          <b-button
            id='closeModal'
            data-dismiss="modal"
          >
            {{ $t('close') }}
          </b-button>

          <LoaderButton
            class="mt-3"
            @click="addDevice"
            :loading="loading"
          >
            {{ $t('save') }}
          </LoaderButton>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL LOADING -->
  <div
    ref='modalLoading'
    id="modalLoading"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalLoading"
    aria-hidden="true"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Carregando...</h5>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-center mb-3">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>

  <LDBsTable
    url="device-log"
    defaultSort="serial"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label>{{ $t('serial') }}</label>
      <input
        type="text"
        class="form-control"
        id="serial"
        name="serial"
        :placeholder="$t('ph_serial')"
        v-model="query.serial"
      >
    </div>
  </LDBsTable>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import { request } from '@/lib/http'
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'ReportDevicesToLog',

  components: {
    LDBsTable,
    LoaderButton
  },

  data () {
    return {
      serial: '',
      deviceToAdd: '',
      showModalAddDeviceToLog: false,
      columns: [
        {
          title: this.$t('serial'),
          field: 'serial',
        },
        {
          title: this.$t('board'),
          field: 'board',
        },
        {
          title: this.$t('client'),
          field: 'client',
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: (value, row, item) => {
            return `
              <a
                href="${process.env.VUE_APP_URL_REPORTS_DEVICE_LOGS}${row.serial}.log"
                target="_blank"
                title="Ver logs"
                class="
                  mb-1
                  btn
                  btn-action
                  btn-primary
                  btn-circle
                  light-bottom-shadow
                  text-white
                "
              >
                <i class="fas fa-eye fa-lg" />
              </a>
              <button
                title="Remover"
                data-target="#modalLoading"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${value}"
                data-name='os${value}'
                class="
                  mb-1
                  btn
                  btn-action
                  btn-danger
                  btn-circle
                  light-bottom-shadow
                  text-white
                "
              >
                <i class="fas fa-times fa-lg" />
              </button>
            `
          },
        }
      ],
      devicesToLog: [],
      query: {
        serial: ''
      },
      queryToUse: {},
      options: {
        exportOptions: { fileName: 'devicelogs' }
      },
      loading: false
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.serial = ''
    },

    async deleteDevice(id) {
      try {
        const { data } = await request({
          method: 'delete',
          url: `device-log/${id}`
        })

        setTimeout(() => {
          $('#modalLoading').modal('hide')

          $('#search').trigger('click')
        }, 1000)

      } catch (error) {
        console.log('[ERROR-DELETE-DEVICE] => ', error)
      }
    },

    async addDevice() {
      try {
        this.loading = true

        const { data } = await request({
          method: 'post',
          url: `device-log`,
          data: { serial: this.deviceToAdd }
        })

        $('#modalAddDeviceToLog').modal('hide')
      } catch (error) {
        console.log('[ERROR-DELETE-DEVICE] => ', error)
      } finally {
        this.loading = false
        $('#search').trigger('click')
        this.deviceToAdd = ''
      }
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['devicelog'] ? this.lastquery['devicelog'] : this.query
  },

  async mounted () {
    if (this.lastquery['devicelog']) {
      for (const [key, value] of Object.entries(this.lastquery['devicelog'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    $('#btn_add_device_to_log').on('click', function() {
      $('#modalAddDeviceToLog').modal('show')
    })

    const global = this

    $('#modalLoading').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      global.deleteDevice(button.data('id'))
    })
  },

  destroyed () {
    this.$store.dispatch('filtershistory/setQuery', { key: 'devicelog', query: this.query })
  },
}
</script>
